import { render, staticRenderFns } from "./benefitHeader.vue?vue&type=template&id=3817ab18&"
import script from "./benefitHeader.vue?vue&type=script&lang=js&"
export * from "./benefitHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports